import requester, { createRequestHeaders } from '@zg-rentals/particles-js-requester';

export const getMessageCount = async (
  proxyPath: string,
  csrf_token: string,
  api: string,
): Promise<{ response: { unreadCount: number } }> => {
  const client = requester({
    proxyPath,
    api,
    headers: {
      ...createRequestHeaders({
        method: 'get',
      }),
      ...{
        rental_csrftoken: csrf_token,
      },
    },
  });

  const response = await client.get('/rental-manager-api/api/v1/users/listingConversation/cachedConversationCounts');

  return response.data as { response: { unreadCount: number } };
};

export const registerTrackingEvent = async (
  proxyPath: string,
  csrf_token: string,
  api: string,
  trackingEvent: string,
): Promise<{ response: { unreadCount: number } }> => {
  const client = requester({
    proxyPath,
    api,
    headers: {
      ...createRequestHeaders({
        method: 'get',
      }),
      ...{
        rental_csrftoken: csrf_token,
      },
    },
    params: { trackingEvent },
  });

  const response = await client.get(`/rental-manager-api/api/v1/users/tracking`);

  return response.data;
};

export const getFeatureFlags = async (
  proxyPath: string,
  csrf_token: string,
  api: string,
): Promise<{ appConfig: { config: Record<string, unknown> } }> => {
  const client = requester({
    api,
    proxyPath,
    params: {
      appName: 'zrm_web',
    },
    headers: {
      ...createRequestHeaders({
        method: 'get',
      }),
      ...{
        rental_csrftoken: csrf_token,
      },
    },
  });

  const response = await client.get('/rental-manager-api/api/v1/multibrandSupport/appConfig');

  return response.data as { appConfig: { config: Record<string, unknown> } };
};
